<template>
  <TabsContainer
    :tabNames="tabNames"
    class="tabs-container-wrapper guide-forms-settings"
  >
    <div slot="tab-0">
      <HkldDropzone
        v-if="allowEdit()"
        :sourceId="DOCS_SOURCE_TYPE.USER_GUIDE"
        :action="ActionTypes.settings.doc.userGuide.create"
        :metaData="guideDefaultOptions"
        :uploadDocTypes="MIME_TYPES.ALL"
        :uploadDocMaxSize="1024"
      />
      <EditUserGuide
        :sourceId="DOCS_SOURCE_TYPE.USER_GUIDE"
        :canEdit="allowEdit()"
        :canDelete="allowEdit()"
        :canDownloadAll="false"
        :action="ActionTypes.settings.doc.userGuide.delete"
      />
    </div>
    <div slot="tab-1">
      <HkldDropzone
        v-if="allowEdit()"
        :sourceId="DOCS_SOURCE_TYPE.FORMS"
        :action="ActionTypes.settings.doc.forms.create"
        :metaData="formsDefaultOptions"
        :uploadDocTypes="MIME_TYPES.ALL"
        :uploadDocMaxSize="1024"
      />
      <EditForms
        :sourceId="DOCS_SOURCE_TYPE.FORMS"
        :canEdit="allowEdit()"
        :canDelete="allowEdit()"
        :canDownloadAll="false"
        :action="ActionTypes.settings.doc.forms.delete"
      />
    </div>
  </TabsContainer>
</template>

<script>
import TabsContainer from '@/controls/TabsContainer'
import HkldDropzone from '@/controls/HkldDropzone'
import EditUserGuide from '@/controls/EditUserGuide'
import EditForms from '@/controls/EditForms'
import {aclHelper} from '@/utils/aclHelper'
import { ActionTypes, DOCS_SOURCE_TYPE, MIME_TYPES } from '@/utils/consts'

export default {
  name: 'UserGuideAndForms',
  components: {
    TabsContainer, HkldDropzone, EditUserGuide, EditForms,
  },
  data () {
    return {
      guideDefaultOptions: {
        tenant: '0',
        contractor: '0',
        hklVendor: '0',
        hklUser: '0',
        uploadOnTop: true,
      },
      formsDefaultOptions: {
        tenantESXQ: '0',
        tenantNonESXQ: '0',
        hklVendorESXQ: '0',
        hklVendorNonESXQ: '0',
        hklUser: '0',
        uploadOnTop: true,
      },
      ActionTypes,
      DOCS_SOURCE_TYPE,
      MIME_TYPES,
    }
  },
  computed: {
    tabNames () {
      return [this.$t('settings.userGuideAndForms.userGuide'), this.$t('settings.userGuideAndForms.forms')]
    },
  },
  methods: {
    allowEdit () {
      return aclHelper.getSettingsUpdateAccess()
    },
  },
}
</script>

<style lang="scss" scoped>
.guide-forms-settings ::v-deep {
  .edit-button-group {
    float: right;
    margin-bottom: 15px;
    width: auto; // The button float to left randomly
  }

  .edit-button-group button {
    margin-left: 8px;
  }
}
</style>
